import React, { useMemo } from "react"
import useProgressiveImage from "@ohs/use-progressive-image"
import SkeletonLoader from "../components/SkeletonLoader"

interface ImageSource {
  srcSet: string
  type: string
}

interface ImageProps {
  lqip?: string
  src: string
  avif?: string
  alt?: string
  width?: string | number
  height?: string | number
}

const Image: React.FC<ImageProps> = ({ 
  lqip, 
  src, 
  avif, 
  alt, 
  width = "100%", 
  height = "auto" 
}) => {
  const sources = useMemo<ImageSource[]>(
    () => [
      {
        srcSet: avif || "",
        type: "image/avif"
      }
    ],
    [avif]
  )

  const [loading] = useProgressiveImage({ img: src, sources })

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width,
        height
      }}
      aria-busy={loading}
      aria-label={alt || "Image loading"}
    >
      <picture
        style={{
          width: "100%",
          height: "100%",
          display: "block"
        }}
      >
        {!loading && <source {...sources[0]} />}
        {loading ? (
          <SkeletonLoader
            count={1}
            height={height}
            width={width}
            aria-hidden="true"
          />
        ) : (
          <img
            src={src}
            alt={alt || "Decorative image"}
            height={height}
            width={width}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover"
            }}
          />
        )}
      </picture>
    </div>
  )
}

export default Image
